import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'amountPipe',
})
export class AmountPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value == null) return '';

    if (value % 1 === 0) return value.toString();

    return value.toFixed(2);
  }
}
